/* eslint-disable @reatom/unit-naming-rule */
import BigNumber from 'bignumber.js'

import { reatomLimitOrderBase } from './reatom-limit-order-base'

import type { PairModel } from '@root/entities/pair'
import type { TradeApi } from '@root/shared/api'

export const reatomLimitOrderSell = ({
  dto,
  pair,
}: {
  dto: TradeApi.LimitOrderSellDto
  pair: PairModel
}) => {
  const limitOrder = reatomLimitOrderBase({
    dto,
    pair,
  })

  //#region Static
  const sellAmountCurrency = BigNumber(dto.amount)
  //#endregion

  //#region State

  //#endregion

  //#region Computed
  const orderSizeNative = sellAmountCurrency.multipliedBy(
    limitOrder.costAtCreationNative,
  )
  //#endregion

  return {
    ...limitOrder,
    type: 'sell' as const,
    sellAmountCurrency,
    orderSizeNative: orderSizeNative,
  }
}
export type LimitOrderSellModel = ReturnType<typeof reatomLimitOrderSell>
